import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { InvoiceFactoringModal } from './components/invoice-factoring-modal';
import type { IInvoiceFactoringProps } from './types.ts';

export const InvoiceFactoringComponent: React.FC<IInvoiceFactoringProps> = (props) => {
  const { invoice } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<BankOutlined />} onClick={handleOpen}>
        {t('client:factoring')}
      </Button>
      <InvoiceFactoringModal invoice={invoice} isOpen={isModalOpen} onClose={handleClose} />
    </>
  );
};

export const InvoiceFactoring = withRoleGuard<IInvoiceFactoringProps>(InvoiceFactoringComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
